import { Alert } from "@mui/material";
import { type FC, useState } from "react";
import { useSupabase } from "../../../server/supabase/hooks";
import type { UUID } from "../../../utils/uuid";
import { SupabaseMomentService } from "../server/supabase-moment-service";

export const TimezoneWarning: FC<{
  momentId: UUID;
}> = ({ momentId }) => {
  const [outsideWorkingHours, setOutsideWorkingHours] = useState<boolean | null>(null);

  useSupabase(
    async ({ supabase }) => {
      const { data } = await new SupabaseMomentService(supabase).deliveredOutsideWorkingHours(
        momentId,
      );
      setOutsideWorkingHours(data);
    },
    [momentId],
  );

  if (!outsideWorkingHours)
    return <div data-testid={outsideWorkingHours === false ? "tz-warning-empty" : undefined} />;

  return (
    <Alert severity="error">
      Please be aware that this Communication will be received by some employees outside of their
      working or social hours (8am - 6pm)
    </Alert>
  );
};
